import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { API_URL } from './apiConfig';

type RetriableRequestConfig = InternalAxiosRequestConfig & {
  _retry?: boolean;
};

function isAuthEndpoint(url?: string): boolean {
  const value = String(url || '');
  return (
    value.includes('/api/login') ||
    value.includes('/api/verify-2fa') ||
    value.includes('/api/refresh-token') ||
    value.includes('/api/logout')
  );
}

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  timeout: 120_000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  console.log ('process.env.NODE_ENV ', process.env.NODE_ENV);

  if (process.env.NODE_ENV !== 'production') {
    const base = String(config.baseURL || API_URL).replace(/\/+$/, '');
    const path = String(config.url || '');
    const absoluteUrl = /^https?:\/\//i.test(path)
      ? path
      : `${base}${path.startsWith('/') ? path : `/${path}`}`;
    console.debug('[PackOps API]', String(config.method || 'GET').toUpperCase(), absoluteUrl);
  }

  // Authentication is cookie based. Do not attach localStorage bearer tokens.
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as RetriableRequestConfig | undefined;

    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !isAuthEndpoint(originalRequest.url)
    ) {
      originalRequest._retry = true;

      try {
        await api.post('/api/refresh-token');
        return api(originalRequest);
      } catch (refreshError) {
        window.location.href = '/#/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export async function logout(): Promise<void> {
  await api.post('/api/logout');
  sessionStorage.removeItem('currentRunId');
  localStorage.removeItem('runId');
  localStorage.removeItem('currentRunId');
}
